import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

const AdminRoute = ({ children }) => {
    const { isAdminAuthenticated, loading } = useAdminAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: '#0f172a' // Darker bg for admin
            }}>
                <div className="spinner" style={{ width: 40, height: 40, borderColor: 'rgba(255,255,255,0.1)', borderTopColor: '#38bdf8' }}></div>
            </div>
        );
    }

    if (!isAdminAuthenticated) {
        return <Navigate to="/admin/login" />;
    }

    return children;
};

export default AdminRoute;
